import axios from "axios";

let timeoutCallbacks = null;

export const setTimeoutResetCallback = (callbacks) => {
    timeoutCallbacks = callbacks;
};

const instance = axios.create({
    headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
    },
});

instance.interceptors.request.use(
    async config => {
        // Pause session timeout during API calls
        if (timeoutCallbacks?.pauseTimeout) {
            timeoutCallbacks.pauseTimeout();
        }

        // console.log(config.url)
        const token = sessionStorage.getItem('Token');
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }

        // Remove Content-Type header for file uploads
        if (config.data instanceof File) {
            delete config.headers['Content-Type'];
        } else {
            config.headers['Content-Type'] = "application/json";
            // config.headers['X-Requested-With'] = 'XMLHttpRequest';
        }

        return config;
    },
    error => {
        Promise.reject(error)
    });


instance.interceptors.response.use((response) => { // block to handle success case
    // Resume session timeout after API completes
    if (timeoutCallbacks?.resumeTimeout) {
        timeoutCallbacks.resumeTimeout();
    }
    return response;
}, function (error) { // block to handle error case
    // Resume session timeout after API error
    if (timeoutCallbacks?.resumeTimeout) {
        timeoutCallbacks.resumeTimeout();
    }
    // const originalRequest = error.config;
    console.log("error", error)
    if (error?.response?.data?.message) {
        return Promise.reject(error.response.data.message);
    }

    return Promise.reject("Unable to process request");
});

export default instance;